module.exports = __webpack_public_path__ + "img/screenshot.09610487.jpg";